import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  FlatList,
  ScrollView,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { checkOut, fetchBillDetailsWithRetry, guestBillDetails, guestHistory, sendGuestMail } from '../../Redux/Actions/viewBillAction';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { calculateTimeDifference, generateToken, getCleanUrl } from '../../utils/Helper';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';
import CustomFlatList from '../../components/customFlatList';
import InfoPopupModal from '../../components/infoPopupModal';
import { setGoHome, setInitAppLogout, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { formatDate } from '../../js/formatDate';
import FetchingDataScreen from '../../components/fetchingDataScreen';
import { useFocusEffect } from '@react-navigation/native';
import { sendAnalytics } from '../../Redux/Actions/analyticsAction';
import { CHECK_OUT_FAILED, CHECK_OUT_SUCCESS, CLICKED, EXIT, INITIAL_LOADER_SCREEN, MY_BILL_CATEGORY } from '../../config/Constant';
import { CHECK_CIRCLE } from '../../assets';



const MyBill = ({ navigation }) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());
  const [myBillSessionToken, setmyBillSessionToken] = useState(() => generateToken("mybill_"));
  const [modalState, setModalState] = useState({
    isInfoModalVisible: false,
    checkoutStatus: '',
    title: t('viewBill.checkout'),
    subTitle: t('viewBill.are_you_sure'),
    onClose: ()=>{},
    onContinue: ()=>{}
  })

  const [loadingState, setLoadingState] = useState({
    loading: false,
    loaderMessage: ''
  })
  const [initialLoading, setInitialLoading] = useState(false);

  const [checkoutConfirmVisible, setCheckoutConfirmVisible] = useState(false);


  const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
  const currencyCode = currencyDetails.code;

  const { isLoggedIn, loggedInRoomNumber } = useSelector((state) => state.appConfigSlice);
  const { guestBillDetailsData, error } = useSelector(
    state => state.guestBillDetailsSlice,
  );

  const { currentGuestDetails } = useSelector(
    state => state.guestDetailsSlice,
  );

  const { currentWidget, extraConfigParam } = useSelector(
    state => state.deviceConfigSlice,
  );
  const dateFormat = extraConfigParam?.DATE_FORMAT;


  let reservationNumber = currentGuestDetails?.reservationNumber
  let locationId = currentGuestDetails?.location
  let arrival = currentGuestDetails?.checkInDate
  let checkout = currentGuestDetails?.plannedCheckOutDate
  let balanceAmount = guestBillDetailsData?.payload?.billTotal?.balanceAmount
  let billItems = guestBillDetailsData?.payload?.rawBill?.billItems
  let billTotal = guestBillDetailsData?.payload?.billTotalStr

  let expressCheckoutIntervalTime = extraConfigParam?.EXPRESS_CHECKOUT_TIME_INTERVALS
  // let expressCheckoutIntervalTime = ''

  let guestBillIntervalTime = expressCheckoutIntervalTime?.split(",")[2]

  const fetchData = async () => {
    setInitialLoading(true)
    handleCheckoutConfirmVisibility(false)
    try {
      const {status, response} = await dispatch(guestHistory(reservationNumber, locationId, guestBillIntervalTime));
      if(!status){
        setModalState(prev => ({
          ...prev,
          isInfoModalVisible: true,
          checkoutStatus: 'retry',
          title: null,
          subTitle: response,
          onClose: handleGoBack,
          onContinue: retryBillDetails
        }))
      }
    } catch (error) {
    } finally {
      setInitialLoading(false)
    }
  };

  const retryBillDetails = async () => {
    setInitialLoading(true);
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false,
    }))
    try{
      const response = await dispatch(fetchBillDetailsWithRetry(reservationNumber, locationId));
      
    }catch (error) {
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: true,
        checkoutStatus: 'retry',
        title: null,
        subTitle: error,
        onClose: handleGoBack,
        onContinue: retryBillDetails
      }))
    }finally {
      setInitialLoading(false)
    }
  }


  useFocusEffect(useCallback(() => {
    dispatch(sendAnalytics(MY_BILL_CATEGORY, CLICKED, { element: "widget", widgetSessionId: myBillSessionToken }))

    return () => {
      const widgetCloseTime = new Date;
      const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
      dispatch(sendAnalytics(MY_BILL_CATEGORY, EXIT, { element: "widget", "duration": widgetCloseDuration, widgetSessionId: myBillSessionToken }))
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []))

  const handleCheckoutConfirmVisibility = (visible = !checkoutConfirmVisible) => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false
    }))
    setCheckoutConfirmVisible(visible)
  };

  const handleCheckoutPress = async () => {
    await dispatch(sendGuestMail(currentGuestDetails?.guestProfile?.email, locationId))
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: true
    }))
  };

  const onSuccess = async (msg) => {
    try{
      const response = await dispatch(guestBillDetails(reservationNumber, locationId));

      console.log(response)

      if(response?.payload?.XC?.Status == "SUCCESS"){
        setModalState(prev => ({
          ...prev,
          isInfoModalVisible: true,
          checkoutStatus: 'success',
          onClose: null,
          onContinue: onSuccessLogout
        }))
        
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - SUCCESS", {element: "widget", widgetSessionId: myBillSessionToken }))

      } else if(response?.payload?.XC?.Status == "FAILED"){
        onFailure(response?.payload?.XC?.Message);
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": response?.payload?.XC?.Message }))
      } else {
        setModalState(prev => ({
          ...prev,
          isInfoModalVisible: true,
          checkoutStatus: 'retry',
          title: t('viewBill.checkoutFailed'),
          subTitle: t('viewBill.checkoutFailedMsg'),
          onClose: handleGoBack,
          onContinue: () => {handleInfoModalClose(); fetchData()}
        }))
        dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": response?.header?.status?.msg }))
      }
      
      
    } catch (err){
      console.log("Guest History: ", err);

      onFailure(err?.message)
      
      dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": err?.message }))
    } finally {
      setLoadingState({
        loading: false,
        loaderMessage: null
      })
    }
  }
  const onFailure = (msg) => {
    let errMessage = msg || t('viewBill.checkoutFailedMsg')
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: true,
      checkoutStatus: 'retry',
      title: t('viewBill.checkoutFailed'),
      subTitle: errMessage || t('viewBill.checkoutFailedMsg'),
      onClose: handleGoBack,
      onContinue: () => {handleInfoModalClose(); fetchData()}
    }))
    setLoadingState({
      loading: false,
      loaderMessage: null
    })

    dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": errMessage }))
  }

  const handleContinue = async () => {
    setLoadingState({
      loading: true,
      loaderMessage: t('viewBill.checkingOut')
    })
    try {
      await dispatch(checkOut(currentGuestDetails, billTotal, onSuccess, onFailure));

    } catch (error) {
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: false
      }))
      dispatch(sendAnalytics(MY_BILL_CATEGORY, "CHECKOUT - FAILED", { element: "widget", widgetSessionId: myBillSessionToken, "errorMessage": error }))
    } finally {
      
    }
  };

  const handleGoBack = () => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false
    }))

    if(navigation.canGoBack()){
      navigation.goBack();
    }
  }

  const onSuccessLogout = () => {
    dispatch(setInitAppLogout(true));
  }
  

  const handleInfoModalClose = () => {
    setModalState(prev => ({
      ...prev,
      isInfoModalVisible: false,
      checkoutStatus: undefined,
      title: t('viewBill.checkout'),
      subTitle: t('viewBill.are_you_sure'),
      onClose: handleInfoModalClose,
      onContinue: handleCheckoutConfirmVisibility
    }))
  };

  const handleCloseModal = () => {
    // setShowTryAgainModal(false);
    dispatch(setGoHome(true));
  };

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(setShowLoginModal(true))
      dispatch(setGoHome(true));
      return;
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(()=>{
    setModalState({
      isInfoModalVisible: false,
      checkoutStatus: '',
      title: t('viewBill.checkout'),
      subTitle: t('viewBill.are_you_sure'),
      onClose: handleInfoModalClose,
      onContinue: handleCheckoutConfirmVisibility
    })
    if(!expressCheckoutIntervalTime){
      setLoadingState(prev => ({
        ...prev,
        loading: false
      }))
      setModalState(prev => ({
        ...prev,
        isInfoModalVisible: true,
        checkoutStatus: 'error',
        title: t("viewBill.express_checkout_interval_time_err_title"),
        subTitle: t("viewBill.express_checkout_interval_time_err"),
        onClose: null,
        onContinue: handleGoBack
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[expressCheckoutIntervalTime, t])

  return (
    <View id='widgetRootContainer' style={getStyles(['widgetRootContainer'])}>
      <HeaderWithBack handleCustomBackPress={checkoutConfirmVisible ? () => handleCheckoutConfirmVisibility(false) : undefined} />
      {loadingState.loading &&  <FetchingDataScreen loaderMessage={loadingState.loaderMessage}/>}
      {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN || "FETCHING_LOADER")}


        <ScrollView id='widgetmainContainer viewbillMainContainer' contentContainerStyle={getStyles(['widgetmainContainer', 'viewbillMainContainer'])} showsVerticalScrollIndicator={false} >
          {checkoutConfirmVisible ? 
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'viewBillConfirmCheckoutHeaderContainer'])}>
              <ImageComp source={CHECK_CIRCLE} style={getStyles(['widgetmainContainerHeaderImg', 'viewBillConfirmCheckoutMainContainerHeaderImg'])} />
  
              <View style={[getStyles(['widgetmainContainerHeaderTitleContainer', 'viewBillConfirmCheckoutMainContainerHeaderTitleContainer'])]}>
                  <Text style={getStyles(['widgetmainContainerHeaderTitle', 'viewBillConfirmCheckoutMainContainerHeaderTitle'])}>{t("viewBill.checkout_confirm_header")}</Text>
                  <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'viewBillConfirmCheckoutMainContainerHeaderSubTitle'])}>{t("viewBill.checkout_confirm_subheader")}</Text>
              </View>
            </View>
          : isLoggedIn && <CustomFlatList
            viewPortHeight={true}
            showsVerticalScrollIndicator={false}
            ListHeaderComponent={
              <View>
                <ImageComp  id='widgetmainContainerHeaderImg ViewBillWidgetHeaderImg' source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'ViewBillWidgetHeaderImg'])} />
                  <View id='billContainer' style={getStyles(['billContainer'])}>
                    <Text id='widgetmainContainerHeaderTitle billHeaderTitle' style={getStyles(["widgetmainContainerHeaderTitle", 'billHeaderTitle'])}>{t('viewBill.heading')}</Text>
                    <Text style={getStyles(["billHeaderSubTitle"])}>{t('viewBill.sub_heading')}</Text>

                    <Text id='total' style={getStyles(['total'])}>{t('viewBill.total')}</Text>
                    <Text id='amount' style={getStyles(['amount'])}>{currencyCode} {balanceAmount ? balanceAmount : 0}</Text>

                    {(arrival && checkout) ? 
                      <View style={getStyles(['viewBillDateContainer'])} id='viewBillDateContainer'>
                        <View style={getStyles(["viewBillDateItemContainer"])} id='viewBillDateItemContainer'>
                          <Text id='viewBillDateItemTitle' style={getStyles(['viewBillDateItemTitle'])}>{formatDate(arrival.split("T")[0], dateFormat)}</Text>
                        </View>
      
                        <View style={getStyles(["viewBillDateItemContainer"])} id='viewBillDateItemContainer'>
                          <Text id='viewBillDateItemTitle' style={getStyles(['viewBillDateItemTitle'])}>Duration</Text>
                          <Text id='viewBillDateItemSubTitle viewBillDateItemDurationSubTitle' style={getStyles(['viewBillDateItemSubTitle', "viewBillDateItemDurationSubTitle"])}>
                            {(() => {
                              const start = new Date(arrival);
                              const end = new Date(checkout);
      
                              start.setHours(0, 0, 0, 0);
                              end.setHours(0, 0, 0, 0);
      
                              const diffTime = end - start;
                              const nights = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0);
                              return `${nights} Night${nights !== 1 ? 's' : ''}`;
                            })()}
                            </Text>
                        </View>
                        
                        <View style={getStyles(["viewBillDateItemContainer"])} id='viewBillDateItemContainer'>
                          <Text id='viewBillDateItemTitle' style={getStyles(['viewBillDateItemTitle'])}>{formatDate(checkout.split("T")[0], dateFormat)}</Text>
                        </View>
                      </View> 
                      : null
                    }



                    <View id='historyContainer' style={getStyles(['historyContainer'])}>
                      <Text id='purcharseBillText' style={getStyles(['purcharseBillText'])}>{t('viewBill.purchase_history')}</Text>
                      <Text id='reviewBill' style={getStyles(['reviewBill'])}>{t('viewBill.review_bill')}</Text>
                    </View>
                  </View>
              </View>
            }
            data={billItems}
            keyExtractor={(item, index) => index.toString()}
            renderItem={({ item }) => (
              <View id='list_itemContainer viewBill_Item_textContainer' style={getStyles(['list_itemContainer', 'viewBill_Item_textContainer'])}>
                <View id='list_itemContainer_textContainer ViewBill_itemContainer_textContainer_title' style={getStyles(['list_itemContainer_textContainer', 'ViewBill_itemContainer_textContainer_title'])}>
                  {item?.itemDesc && <Text id='list_itemContainer_textContainer_title ViewBill_itemContainer_textContainer_title' style={getStyles(['list_itemContainer_textContainer_title', 'ViewBill_itemContainer_textContainer_title'])}>{item?.itemDesc}</Text>}
                </View>

                <View id='list_itemContainer_arrow ViewBillWidgetChildContainer_itemContainer_arrow' style={getStyles(['list_itemContainer_arrow', 'ViewBillWidgetChildContainer_itemContainer_arrow'])}>
                  {item?.itemAmount && <Text id='list_itemContainer_textContainer_subtitle ViewBill_itemContainer_textContainer_subtitle' style={getStyles(['list_itemContainer_textContainer_subtitle', 'ViewBill_itemContainer_textContainer_subtitle'])} numberOfLines={2} ellipsizeMode="tail">{currencyCode} {item?.itemAmount}</Text>}

                </View>
              </View>

            )}
            ListEmptyComponent={ expressCheckoutIntervalTime &&
              <View id='list_itemContainer viewBill_Item_textContainer' style={getStyles(['list_itemContainer', 'viewBill_Item_textContainer'])}>
                <View id='list_itemContainer_textContainer ViewBill_itemContainer_textContainer_noHistory_container' style={getStyles(['list_itemContainer_textContainer', 'ViewBill_itemContainer_textContainer_noHistory_container'])}>
                <Text id='list_itemContainer_textContainer_noHistory ViewBill_itemContainer_textContainer_noHistory' style={getStyles(['list_itemContainer_textContainer_noHistory', 'ViewBill_itemContainer_textContainer_noHistory'])}>
                  {t("viewBill.no_history_present")}
                </Text>
                </View>
              </View>
            }
          />}
        </ScrollView>

      <View id='billCheckoutBtnContainer' style={getStyles(['billCheckoutBtnContainer'])}>
        <CustomPressable id='primaryBtn' onPress={() => checkoutConfirmVisible ? handleContinue() : handleCheckoutPress()} style={getStyles(['primaryBtn'])} disabled={!expressCheckoutIntervalTime}>
          <Text id='primaryBtnTxt' style={getStyles(['primaryBtnTxt'])}>
            {checkoutConfirmVisible ? t('viewBill.confirm_checkout') : t('viewBill.checkout')}
          </Text>
        </CustomPressable>
      </View>


      {modalState.isInfoModalVisible && !loadingState.loading && 
      <InfoPopupModal
        type={modalState.checkoutStatus}
        title={modalState.checkoutStatus != 'loading' ? modalState.title : null}
        subtitle={modalState.checkoutStatus !== 'loading' && modalState.checkoutStatus !== 'success' ?  modalState.subTitle : null}
        onClose={modalState.onClose}
        OnRequestClose={modalState.onClose}
        onContinue={modalState.onContinue}
        isVisible={modalState.isInfoModalVisible}
        primaryBtnLabel={modalState.checkoutStatus == 'error' ? t('viewBill.on_error_primray_button_title') : modalState.checkoutStatus == 'retry' ? t('viewBill.retry') : null}
      >
        {!modalState.checkoutStatus && <View id='viewBill_infoModalRowView' style={getStyles(['viewBill_infoModalRowView'])} >
          <View>
            <Text id='viewBill_infoModalSubheader' style={getStyles(['viewBill_infoModalSubheader'])}>{t('viewBill.total')}</Text>
            <Text id='viewBill_infoModalTitle' style={getStyles(['viewBill_infoModalTitle'])}>{currencyCode} {billTotal ? billTotal : 0}</Text>
          </View>
          <View >
            <Text id='viewBill_infoModalSubheader' style={getStyles(['viewBill_infoModalSubheader'])}>
              {t('viewBill.room')}
            </Text>
            <Text id='viewBill_infoModalTitle' style={getStyles(['viewBill_infoModalTitle'])}>
              {loggedInRoomNumber || 'N/A'}
            </Text>
          </View>
        </View>}

      </InfoPopupModal>}
    </View>
  );
};


export default MyBill;
